import FindFavoritesStore from './schema/FindFavoritesStore';
import { createStore } from 'satcheljs';

const defaultStore: FindFavoritesStore = {
    findText: '',
};

export default createStore<FindFavoritesStore>('findFavorites', defaultStore)();
